import { GridPaginationModel, GridRowHeightParams, GridRowHeightReturnValue, GridSortItem, GridSortModel } from "@mui/x-data-grid-pro";
import { CentralDataGridPro, GridBox } from "components/shared/grids";
import { FC, useState } from "react";
import { GridMetaData } from "models/grids";
import WorkItemReviewChangesColumns from "./grid/WorkItemReviewChangesColumns";
import { IChangedWorkItemResourceAssigne } from "models/work-items/IChangedWorkItemResourceAssignee";
import { DrawerFooter, DrawerHeader, SideDrawer } from "@sagecentral/core-ui";
import { BulkUpdateModes } from "./WorkItemBulkUpdate";

type IOwnProps = {    
    open: boolean;
    onClose: () => void;
    changedItems: IChangedWorkItemResourceAssigne[];
    onConfirm: () => void;
    onEdit: () => void;    
}

const WorkItemResourceReviewChanges: FC<IOwnProps> = (props: IOwnProps) => {
    const defaultPage = 0;
    const defaultPageSize = 10;
    const defaultSort: GridSortItem[] = [{
        field: 'workItemInstanceId',
        sort: 'asc'
    }];

    const [pageModel, setPageModel] = useState<GridPaginationModel>({ page: defaultPage, pageSize: defaultPageSize });
    const [gridMetaData, setGridMetaData] = useState<GridMetaData>({
        page: pageModel.page,
        pageSize: pageModel.pageSize,
        sort: defaultSort.map(s => {
            return { field: s.field, dir: s.sort };
        })
    });

    const handlePaginationModelChange = async (model: GridPaginationModel) => {
        setPageModel({
            page: model.page,
            pageSize: model.pageSize
        });
        gridMetaData.page = model.page;
        gridMetaData.pageSize = model.pageSize;
        setGridMetaData(gridMetaData);
    }

    const onClose = (event?: any) => {
        if (event) {
            event.preventDefault();
        }
        props.onClose();
    }

    const getData = () => {
        return props.changedItems;
    }

    return (
        <SideDrawer
            onClose={onClose}
            open={props.open}
            header={
                <DrawerHeader
                    title='Bulk Update Work Items Resources Confirmation'
                    onClose={onClose} />
            }
            footer={
                <DrawerFooter                    
                    onConfirm={props.onConfirm}
                    confirmText="Confirm"
                    cancelText="Edit"
                    onCancel={props.onEdit} />
            }
        >
            {
                props.open && <>
                    <div
                        style={{ marginBottom: '20px' }}>
                        Please review the following pending resource changes.
                    </div>
                    <GridBox getData={getData}>
                        {props.changedItems.length > 0 &&
                            <CentralDataGridPro
                                rows={props.changedItems}
                                rowCount={props.changedItems.length}
                                loading={false}
                                columns={WorkItemReviewChangesColumns}
                                rowSelection={false}
                                filterMode="client"
                                getRowHeight={() => 'auto'}
                                sortingMode="client"
                                paginationModel={pageModel}
                                onPaginationModelChange={handlePaginationModelChange}
                                pageSizeOptions={[10, 25, 50, 75, 100]}
                                pagination={getData() && getData().length > 0}
                            />
                        }
                    </GridBox>
                </> || <></>
            }
        </SideDrawer>
    )
}

export default WorkItemResourceReviewChanges;